export const isClosingTime = (
  ct: ClosingTime | undefined
): ct is ClosingTime => {
  const ctCurrent = ct as ClosingTime;
  return (
    ctCurrent !== undefined &&
    ctCurrent.closingTime !== undefined &&
    ctCurrent.closingTime !== null &&
    ctCurrent.discountPercent !== undefined &&
    ctCurrent.discountPercent !== null &&
    ctCurrent.discountPeriod !== undefined &&
    ctCurrent.discountPeriod !== null
  );
};
